module.exports = __webpack_public_path__ + "img/AGRI.be61fab1.jpg";